import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'

import { httpOk, DELETE, GET, POST, PUT } from 'helpers/api'
import { formatMoneyInput } from 'helpers/helpers'
import PageHeader from './PageHeader'
import ValidPeriod from './ValidPeriod'

// Акционная скидка на доставку (Фаза 4): процент/фикс к стоимости доставки, 100% = бесплатно.
// Движок условий тот же, что у остальных акций (дни/время, тип заказа, филиалы, порог суммы).
function CreateUpdateDeliveryDiscount() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()

	const [poses, setPoses] = useState([])
	const [orderTypeSubs, setOrderTypeSubs] = useState([])
	const [data, setData] = useState({
		"name": "",
		"cheque_amount": "",
		"discount_payment_type": 2,
		"discount_payment_value": "",
		"days": [],
		"poses": [],
		"order_type_subs": [],
	})

	const isPercent = Number(data.discount_payment_type) === 2

	async function createUpdate() {
		var dataCopy = { ...data }

		var response
		if (!dataCopy.id) {
			response = await POST('/discount/services-delivery-discount', dataCopy, { loader: true })
		} else {
			response = await PUT('/discount/services-delivery-discount', dataCopy, { loader: true })
		}

		if (httpOk(response)) navigate(-1)
	}

	function handleChangeTime(e, index, type) {
		var dataCopy = { ...data }
		dataCopy.days[index][type] = e.target.value
		setData(dataCopy)
	}

	function setDayStatus(index, key) {
		var dataCopy = { ...data }
		dataCopy.days[index][key] = !dataCopy.days[index][key]
		setData(dataCopy)
	}

	function addTime() {
		var dataCopy = { ...data }
		dataCopy.days.push({
			"start_time": "",
			"end_time": "",
			"day1": false,
			"day2": false,
			"day3": false,
			"day4": false,
			"day5": false,
			"day6": false,
			"day7": false,
		})
		setData(dataCopy)
	}

	async function deleteDay(item, index) {
		var dataCopy = { ...data }
		if (item.id) {
			const response = await DELETE(`/discount/services-promo-day/${item.id}`, {}, { loader: true })
			if (httpOk(response)) {
				dataCopy.days.splice(index, 1)
			}
		} else {
			dataCopy.days.splice(index, 1)
		}
		setData(dataCopy)
	}

	async function getData() {
		const response = await GET('/helper/poses', {}, { loader: true })
		if (httpOk(response)) setPoses(response.data)

		const responseOrderTypeSubs = await GET('/helper/order-type-subs', {}, {})
		if (httpOk(responseOrderTypeSubs)) setOrderTypeSubs(responseOrderTypeSubs.data)

		if (id) {
			const response = await GET(`/discount/services-delivery-discount/${id}`, {}, { loader: true })
			if (httpOk(response)) setData(response.data)
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<PageHeader typeKey="discount_delivery" />

			<div className="card mb-3">
				<div className="card-body">
					<div className="row">
						<div className="col-md-4 border-right">
							<div className="form-group">
								<label>{t('name2')}</label>
								<input type="text" className="form-control" name="name" autoComplete="off"
									value={data.name ?? ''}
									onChange={(e) => setData({ ...data, 'name': e.target.value })} />
							</div>
							<ValidPeriod data={data} setData={setData} />
							<div className="form-group">
								<label>{t('poses')}<span className="required-mark">*</span></label>
								<Select
									isMulti
									value={data.poses}
									options={poses}
									onChange={(options) => setData({ ...data, 'poses': options })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<div className="d-flex gap-3">
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setData({ ...data, 'discount_payment_type': 2 })}
										style={{ 'backgroundColor': data.discount_payment_type === 2 ? 'black' : '' }}>
									</div>
									<span onClick={() => setData({ ...data, 'discount_payment_type': 2 })}>
										{t('percentage')}
									</span>
								</div>

								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setData({ ...data, 'discount_payment_type': 1 })}
										style={{ 'backgroundColor': data.discount_payment_type === 1 ? 'black' : '' }}>
									</div>
									<span onClick={() => setData({ ...data, 'discount_payment_type': 1 })}>
										{t('amount')}
									</span>
								</div>
							</div>

							<div className="form-group w-100">
								<label>{t('discount_value')}</label>
								<div className="input-group">
									<input type="text" className="form-control" name="discount_payment_value" autoComplete="off"
										value={formatMoneyInput(data.discount_payment_value) ?? ''}
										onChange={(e) => setData({ ...data, 'discount_payment_value': e.target.value.replace(/[^0-9.]/g, '') })} />
									<span className="input-group-text">{isPercent ? '%' : t('currency_soum')}</span>
								</div>
								<div className="text-muted fz-12 mt-1">{t('discount_delivery_hint')}</div>
							</div>

							<div className="form-group w-100">
								<label>{t('min_order_amount')}</label>
								<input type="text" className="form-control" name="cheque_amount" autoComplete="off"
									value={formatMoneyInput(data.cheque_amount) ?? ''}
									onChange={(e) => setData({ ...data, 'cheque_amount': e.target.value.replace(/[^0-9.]/g, '') })} />
							</div>
							<hr />
							<div className="form-group">
								<label>{t('order_type')}<span className="required-mark">*</span></label>
								<Select
									isMulti
									value={data.order_type_subs}
									options={orderTypeSubs}
									onChange={(options) => setData({ ...data, 'order_type_subs': options })}
									placeholder=""
									noOptionsMessage={() => ""}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						</div>
						<div className="col-md-8">
							<div className="form-group">
								<div className="d-flex gap-2 mb-2">
									<h4 className="fw-600">{t('discount_day_time')}</h4>
									<div className="table-action-button table-action-primary-button"
										onClick={() => addTime()}>
										<i className="uil-plus"></i>
									</div>
								</div>
								<div className="table-responsive">
									<table className="table table-bordered mb-0">
										<thead>
											<tr>
												<th>{t('start')}</th>
												<th>{t('end')}</th>
												<th>{t('monday_short')}</th>
												<th>{t('tuesday_short')}</th>
												<th>{t('wednesday_short')}</th>
												<th>{t('thursday_short')}</th>
												<th>{t('friday_short')}</th>
												<th>{t('saturday_short')}</th>
												<th>{t('sunday_short')}</th>
												<th style={{ 'width': '50px' }}></th>
											</tr>
										</thead>
										<tbody>
											{data?.days?.map((item, index) => (
												<tr key={index}>
													<td>
														<input type="time"
															className="form-control"
															value={(item.start_time || '').slice(0, 5)}
															onChange={(e) => handleChangeTime(e, index, 'start_time')} />
													</td>
													<td>
														<input type="time"
															className="form-control"
															value={(item.end_time || '').slice(0, 5)}
															onChange={(e) => handleChangeTime(e, index, 'end_time')} />
													</td>
													{[1, 2, 3, 4, 5, 6, 7].map((day) => (
														<td key={day} className="vertical-middle">
															<input type="checkbox" className="form-check-input"
																checked={item[`day${day}`] ?? false}
																onChange={() => setDayStatus(index, `day${day}`)} />
														</td>
													))}
													<td>
														<div className="table-action-button table-action-danger-button"
															onClick={() => deleteDay(item, index)}>
															<i className="uil-times"></i>
														</div>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

					<div className="btn-wrapper gap-2">
						<Link className="btn btn-warning btn-rounded btn-wide" to="/discount/services" tabIndex="-1">
							{t('cancel')}
						</Link>
						<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
							onClick={() => createUpdate()}>
							{t('save')}
						</button>
					</div>

				</div>
			</div>
		</>
	)
}

export default CreateUpdateDeliveryDiscount
